import { getSearchConfig } from "@/components/dynamic-form/helper/getSearchConfig";
import { SearchBarType } from "@/components/dynamic-form/constants";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { usePlatformOptions } from "@/pages/consumption/hooks/usePlatformOptions";
import { useAccountOptions } from "@/pages/consumption/hooks/useAccountOptions";
import { useProjectOptions } from "@/pages/consumption/hooks/useProjectOptions";
import dayjs from "project-config/utils/dayjs";
import { getToday, ONE_WEEK } from "@/utils/date-formatter/getToday";

export function useSearchConfig() {
  const platformOptions = usePlatformOptions();
  const accountOptions = useAccountOptions();
  const projectOptions = useProjectOptions();

  const now = getToday();
  const weekAgo = new Date(now.getTime() - ONE_WEEK);

  const searchConfig = getSearchConfig(() => {
    const t = getTranslateNsT("center");
    return [
      {
        type: SearchBarType.DatePicker,
        field: "time",
        label: t("consumption_time_selector"),
        limitMonthNum: 3,
        isTrendsChangeDate: true,
        props: {
          allowClear: false,
          defaultValue: [dayjs(weekAgo), dayjs(now)],
        },
      },
      {
        type: SearchBarType.Select,
        field: "userId",
        label: t("user_operate_record_user_name"),
        props: {
          options: accountOptions,
          placeholder: t("custom_display_text_all"),
        },
      },
      {
        type: SearchBarType.Select,
        field: "platform",
        label: t("user_consume_pick_platform"),
        props: {
          options: platformOptions,
          placeholder: t("custom_display_text_all"),
        },
      },
      {
        type: SearchBarType.Select,
        field: "projectId",
        label: t("render_table_sort_projectName"),
        props: {
          options: projectOptions,
          showSearch: true,
          filterOption: (input, option) => {
            return (
              (option?.label as string)
                ?.toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            );
          },
          placeholder: t("custom_display_text_all"),
        },
      },
      {
        type: SearchBarType.Input,
        field: "company",
        label: t("consumption_table_header_company"),
        props: {
          allowClear: true,
          placeholder: t("user_binfo_perfect_item_company_placeholder"),
        },
      },
    ];
  });
  return { searchConfig };
}
